import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import VisibilityActionButton from '../../../../components/designe/ActionButtons/VisibilityActionButton';
import { successToastMessage } from '../../../../components/layout/toast-root/toast';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { Paths } from '../../../../shared/paths';
import { AuthPrimaryButton } from '../../components/auth-button';
import AuthTextField from '../../components/auth-text-field';
import { useStyles } from './ResetPassword.styles';
import { useResetPasswordPage } from './useResetPasswordPage';

export default function ResetPassword() {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get('oobCode') || '';
  const { navigate } = useNavigationStack();
  // const mode = searchParams.get("mode");
  // const apiKey = searchParams.get("apiKey");
  // const lang = searchParams.get("lang");
  const { formik } = useResetPasswordPage(t, oobCode, () => {
    successToastMessage(t('resetPassword.successResetPasswordMessage'));
    navigate(Paths.signIn);
  });

  return (
    <div className={classes.resetPasswordWrapper}>
      <div className={classes.resetPasswordContentWrapper}>
        <form
          onSubmit={formik.handleSubmit}
          className={classes.resetPasswordForm}>
          <AuthTextField
            placeholder={t('resetPassword.password')}
            fullWidth
            name="password"
            type={showPassword ? 'text' : 'password'}
            className={classes.textField}
            errorIconRightPadding={40}
            formik={formik}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <VisibilityActionButton
                    isActive={showPassword}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </InputAdornment>
              ),
            }}
          />
          <AuthTextField
            placeholder={t('resetPassword.confirmPassword')}
            fullWidth
            name="confirmPassword"
            type={showPassword ? 'text' : 'password'}
            className={classes.textField}
            errorIconRightPadding={40}
            formik={formik}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <VisibilityActionButton
                    isActive={showPassword}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </InputAdornment>
              ),
            }}
          />
          <AuthPrimaryButton
            type="submit"
            fullWidth
            className={classes.resetPasswordSubmitButton}>
            {t('resetPassword.resetPassword')}
          </AuthPrimaryButton>
        </form>

        <div className={classes.backToLogin}>
          <Link className={classes.backToLoginButton} to={Paths.signIn}>
            {t('signIn.signIn')}
          </Link>
        </div>
      </div>
    </div>
  );
}
